export default "__VITE_ASSET__Dzq4uEaq__"